import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import { StyledCheckBox } from './StyledProductFormComponent';

const CheckBoxInput = ({
  borderColor = 'var(--page-input-border)',
  focusHighlight = 'var(--page-focus-highlight)',
  checkmarkColor = 'var(--page-highlight)',
  handleFormValues,
  value = false,
  label = null,
  labelColor = 'var(--page-primary-text)',
  labelSize = '1rem',
  customBoxSize = null,
  customCheckmarkSize = null,
  controlled = false,
}) => {
  const [checked, setChecked] = React.useState(value);

  // Keep internal state in sync if not controlled
  React.useEffect(() => {
    if (!controlled) setChecked(value);
  }, [value, controlled]);

  const handleSelection = (e) => {
    if (!controlled) setChecked(e.target.checked);
    handleFormValues(e.target.checked);
  };

  return (
    <Box width="100%">
      <StyledCheckBox
        checked={controlled ? value : checked}
        label={(
          <Box width="100%" justify="center">
            <Text color={labelColor} size={labelSize}>
              {label}
            </Text>
          </Box>
        )}
        labelColor={labelColor}
        onChange={handleSelection}
        borderColor={borderColor}
        focusHighlight={focusHighlight}
        color={checkmarkColor}
        customBoxSize={customBoxSize}
        customCheckmarkSize={customCheckmarkSize}
      />
    </Box>
  );
};

CheckBoxInput.propTypes = {
  borderColor: PropTypes.string,
  focusHighlight: PropTypes.string,
  checkmarkColor: PropTypes.string,
  handleFormValues: PropTypes.func.isRequired,
  value: PropTypes.bool,
  label: PropTypes.string,
  labelColor: PropTypes.string,
  labelSize: PropTypes.string,
  customBoxSize: PropTypes.string,
  customCheckmarkSize: PropTypes.string,
  controlled: PropTypes.bool,
};

export default CheckBoxInput;
